import React, { useState } from 'react';
import Sidebar from '../Components/Sidebar.jsx';
import { TfiHandPointRight } from "react-icons/tfi";
import './Elevation.css';

const ElectricalDrawing = () => {
  const [zoomImage, setZoomImage] = useState(null);

  const ElectricalImages = Array.from({ length: 5 }, (_, i) => `/gallery/Electrical/Electrical_${i + 1}.jpg`);

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />

      <div className="elevation-content">
        <h1 className="service-title">ELECTRICAL DRAWINGS</h1>

        <div className="service-image">
          <img src="/gallery/electrical/Electrical_1.jpg" alt="Electrical Drawing Overview" />
        </div>

        <h3>Why Choose Our Draftsman Services?</h3>
        <ul className="draftsman-points">
          <li><TfiHandPointRight /> Accurate and detailed structural & architectural plans</li>
          <li><TfiHandPointRight /> Expert in 2D planning, sections, and elevations</li>
          <li><TfiHandPointRight /> AutoCAD & Revit supported drafting</li>
          <li><TfiHandPointRight /> Precise measurements and to-scale outputs</li>
        </ul>

        {/* Image Grid Section */}
        <div className="image-grid-section">
          <h2>Gallery of Electrical Drawing Samples</h2>
          <div className="image-grid">
            {ElectricalImages.map((src, index) => (
              <div
                className="grid-image-box"
                key={index}
                onClick={() => setZoomImage(src)}
              >
                <img src={src} alt={`Electrical Drawing ${index + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
        </div>

        {/* Contact Section */}
        <div className="service-contact">
          <h2>Contact Us for More Information</h2>
          <p>If you have any questions or would like to discuss your project, please contact us:</p>
          <ul>
            <li>Email: <a href="mailto:info@example.com">info@example.com</a></li>
            <li>Phone: <a href="tel:+919999999999">+91 99999 99999</a></li>
          </ul>
        </div>
      </div>

      {/* Zoom Modal */}
      {zoomImage && (
        <div className="image-modal" onClick={() => setZoomImage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-button" onClick={() => setZoomImage(null)}>❌</span>
            <img src={zoomImage} alt="Zoomed Electrical Drawing" />
          </div>
        </div>
      )}
    </div>
  );
};

export default ElectricalDrawing;
